export default __webpack_public_path__ + "static/media/msf_background_s2.aaea5a28.jpg";